import styled from '@emotion/styled/macro';

export const Heading = styled.h3`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  text-transform: uppercase;
  margin: 0;
  padding: 0 var(--spacing-30);
`;

// Heading for the three advisory blocks (Corrective Action, Manual Verification,
// Critical Action). Unlike `Heading` it carries no horizontal padding, so it sits
// tight against the block's icon, and it shrinks and ellipsizes so a long label
// can share its row with a trailing control without pushing it out of the box.
export const BlockHeading = styled.h3`
  font-family: 'Roboto Condensed';
  font-style: normal;
  /* 600, not 700: index.css registers RobotoCondensed-Bold.woff2 at weight 600. */
  font-weight: 600;
  font-size: var(--font-size-14);
  text-transform: uppercase;
  margin: 0;
  padding: 0;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
